import { Component, Inject, Input, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import * as _ from "lodash";

import { agentRoles, checkoutFields, decodeData, displayValues, login, order, spekwo, stripeStatus, toastMsg } from '../../../../utils';

import { ConfigurationService } from '../../../../configuration/configuration.service';
import { ToastComponent } from '../../../../common/toast.component';
import { EcommerceOrdersService } from '../../orders.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../../authentication/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuditHistoryService } from '../../../../../../../core/services/audit-history.service';
import { environment } from '../../../../../../../../environments/environment';
import { CommonOrdersService } from '../../commonOrders.service';
import { OrderViewLogsDialogComponent } from '../../../../../../../core/components/order-view-logs/order-view-logs.component';

@Component({
  selector: 'app-orders-edit-new',
  templateUrl: './orders-edit-new.component.html',
  styleUrls: ['./orders-edit-new.component.scss']
})
export class OrdersEditNewComponent implements OnInit {

  userId: string;
  nodeId: string;
  loginValues = login;

  transactionID;
  hostedInvoiceURL: any;
  invoiceObject: any = null;
  chargeObject: any = null;

  @Input() currentOrderInfo;
  formValues = order;
  isLoading: boolean = false;
  currentOrderId: any;

  clientFirstName: string = '';
  clientLastName: string = '';
  clientNameEdit: boolean = false;

  buyerSellerName: string = '';
  buyerSellerNameEdit: boolean = false;

  address: string = '';
  addressEdit: boolean = false;

  agentType: string = '';
  agentTpeEdit: boolean = false;

  agentName: string = '';
  clientPhoneEdit: boolean = false;

  agentEmail: string = '';
  agentEmailEdit: boolean = false;
  emailAgent: string = '';

  clientEmail: string = '';
  clientEmailEdit: boolean = false;

  agentMobile: string = '';
  agentMobileEdit: boolean = false;

  productOrdered: any = '';
  productId = null;
  productOrderedEdit: boolean = false;

  dueDate: string = '';
  dueDateEdit: boolean = false;

  orderedDate: string = '';
  orderedDateEdit: boolean = false;

  additionalEmail: string = '';
  additionalEmailEdit: boolean = false;

  subjectPropertyAddress: string = '';
  subjectPropertyAddressEdit: boolean = false;

  clientMobileNumber: string = '';
  clientMobileNumberEdit: boolean = false;

  productsArray = [];

  orderDetails: any;
  checkoutFields = checkoutFields;
  toastMsg = toastMsg;
  orderDetailsFormGroup: FormGroup;
  email: string = '';
  firstName: string = '';
  phone: string = '';
  clientPropertyRole: string = '';
  clientPhone: string;
  agentRole: string = '';
  agentRoleEdit: boolean = false;
  amountDue: number;
  invoiceStatus: string = '';
  paymentStatus: string = '';
  stripeStatus = stripeStatus;
  displayValues = displayValues;
  orderId: number;
  clientName: string = '';
  isForm: boolean = false;
  createdVia: string = '';
  receiptUrlOfCheckout: string = '';
  currentUserName: string;
  currentUserChangedSubscription: Subscription;
  onRoleSubscription: Subscription;
  role: any;
  spekwoValues = spekwo;
  couponCode: string
  couponAmount: number;
  expireDate: string;
  expireDateFormatted: string;
  couponByCouponId: any;
  roleId: any;
  oldDataList = [];
  wellReport: string;
  wdo: string;
  structuralEng: string;
  ddraReport: string;
  homeInspection: string;
  homeInspectionEdit: boolean = false;
  ddraEdit: boolean = false;
  wdoEdit: boolean = false;
  structuralEngEdit: boolean = false;
  wellEdit: boolean = false;
  productReports = new Map();
  affiliateNameEdit: boolean = false;
  firmNameEdit: boolean = false;
  localMarketEdit: boolean = false;
  markets = [];
  offices: any[] = [];
  firms: any[] = [];
  marketsDropDownMenu = [];
  officesDropDownMenu: any[] = [];
  firmsDropDownMenu: any[] = [];
  isLoadingList = false;
  affiliateName: string;
  affiliateId: number;
  firmName: string;
  firmId: number;
  localMarketName: string;
  localMarketId: number;
  poupClose = false
  dialogRefAudit: any;
  @Output() isReportUpdated: any = new EventEmitter<any>();
  editOrderResponse: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private configurationService: ConfigurationService,
    public toastComponent: ToastComponent,
    private ordersService: EcommerceOrdersService,
    private formBuilder: FormBuilder,
    public authService: AuthService,
    public router: Router,
    public auditHistoryService: AuditHistoryService,
    private _matSnackBar: MatSnackBar,
    public dialogRef: MatDialogRef<OrdersEditNewComponent>,
    private commonOrdersService: CommonOrdersService,
    public route: ActivatedRoute,
    public dialog: MatDialog,

  ) {
    this.getProducts();
    this.orderInfo();
    dialogRef.disableClose = true;
  }

  orderPopup() {
    this.dialogRef.close(this.editOrderResponse);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.currentOrderId = params && params.id ? params.id : this.data.id;
      this.orderInfo();
    }, () => {
      this.isLoading = false;
    });

    if (Object.keys(this.data).length > 0) {
      this.isForm = true;
    }
    this.userId = window.localStorage.getItem('userUID');
    this.roleId = window.localStorage.getItem("roleId");
    this.currentUserChangedSubscription =
      this.authService.onCurrentUserChanged.subscribe(user => {
        this.currentUserName = user.firstName + ' ' + user.lastName;
      });
    this.getAllInvoices();
    this.onRoleSubscription =
      this.authService.onCurrentUserChanged.subscribe(user => {
        this.role = user.roleByRoleId.roleName;

      });
    this.fetchMarkets();
  }

  ngOnDestroy() {
    this.onRoleSubscription.unsubscribe();
    this.currentUserChangedSubscription.unsubscribe();
  }
  /**Logout from app */
  logout() {

    window.localStorage.clear();
    this.router.navigate(['**']);

  }
  getProducts() {
    this.configurationService.getProductsList(null, null).then((productRes: any) => {
      if (productRes && (productRes['nodes'] && productRes['nodes'].length > 0)) {
        this.setDataFormat(productRes['nodes']);
      }
    })
  }

  setDataFormat(response) {
    let temp = [];
    response.forEach((event) => {
      try {
        temp.push({
          productId: event && event.productId ? event.productId : null,
          productName: event && event.productName ? decodeData(event.productName) : null,
          sku: event && event.sku ? decodeData(event.sku) : null,
          productPrice: event && event.productPrice ? ("$ " + event.productPrice.toString()) : null,
          productPriceOrg: event && event.productPrice ? event.productPrice : null,
          productDesc1: event && event.productDesc1 ? decodeData(event.productDesc1) : null,
          isDeletedYn: event && event.isDeletedYn ? event.isDeletedYn : false
        })
        if (response.length == temp.length) {
          this.productsArray = temp;
        }
      }
      catch (err) {
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  // format order data
  formatOrderData(orderInfo) {
    this.orderId = orderInfo && orderInfo.id ? orderInfo.id : -1;
    this.clientFirstName = orderInfo && orderInfo.firstName ? decodeData(orderInfo.firstName) : (orderInfo && orderInfo.first_name ? decodeData(orderInfo.first_name) : "");
    this.clientLastName = orderInfo && orderInfo.lastName ? decodeData(orderInfo.lastName) : (orderInfo && orderInfo.last_name ? (" " + decodeData(orderInfo.last_name)) : "");
    // this.buyerSellerName = orderInfo && orderInfo.agentType ? orderInfo.agentType : '';
    this.agentType = orderInfo && orderInfo.agentType ? orderInfo.agentType : '';
    this.agentName = orderInfo && orderInfo.agentName ? orderInfo.agentName : '';
    this.agentEmail = orderInfo && orderInfo.agentEmail ? orderInfo.agentEmail : '';
    this.productOrdered = orderInfo && orderInfo.product_name ? orderInfo.product_name : '';
    this.productId = orderInfo && orderInfo.productId ? orderInfo.productId : '';
    this.dueDate = orderInfo && orderInfo.dueDate ? orderInfo.dueDate : '';
    this.orderedDate = orderInfo && orderInfo.orderedDate ? orderInfo.orderedDate : '';
    this.additionalEmail = orderInfo && orderInfo.solEmail ? orderInfo.solEmail : '';
    this.subjectPropertyAddress = orderInfo && orderInfo.buyerProperty ? orderInfo.buyerProperty : '';
    this.clientMobileNumber = orderInfo && orderInfo.phone ? orderInfo.phone : '';
    this.orderDetails = orderInfo && orderInfo.orderContent ? JSON.parse(orderInfo.orderContent) : '';
    this.nodeId = orderInfo && orderInfo.nodeId ? orderInfo.nodeId : '';
    this.email = orderInfo && orderInfo.email ? orderInfo.email : '';
    this.phone = orderInfo && orderInfo.phone ? orderInfo.phone : '';
    this.firstName = orderInfo && orderInfo.first_name ? decodeData(orderInfo.first_name) : "";
    this.clientPropertyRole = orderInfo && orderInfo.clientPropertyRole ? orderInfo.clientPropertyRole : '';
    this.buyerSellerName = orderInfo && orderInfo.clientName ? orderInfo.clientName : '';
    this.clientEmail = orderInfo && orderInfo.email ? orderInfo.email : '';
    this.clientPhone = orderInfo && orderInfo.clientphone ? orderInfo.clientphone : '';
    this.emailAgent = orderInfo && orderInfo.clientemail ? orderInfo.clientemail : '';
    this.agentRole = orderInfo && orderInfo.indrole ? orderInfo.indrole : '';
    this.amountDue = orderInfo && orderInfo.totalAmount ? orderInfo.totalAmount : '';
    this.clientName = orderInfo && orderInfo.first_name ? decodeData(orderInfo.first_name) : "";
    this.createdVia = orderInfo && orderInfo.createdVia ? orderInfo.createdVia : '';
    this.couponCode = orderInfo && orderInfo.couponByCouponId && orderInfo.couponByCouponId.couponCode ? orderInfo.couponByCouponId.couponCode : '';
    this.couponAmount = orderInfo && orderInfo.couponByCouponId && orderInfo.couponByCouponId.couponAmount ? orderInfo.couponByCouponId.couponAmount : '';
    this.expireDate = orderInfo && orderInfo.couponByCouponId && orderInfo.couponByCouponId.expireDate ? orderInfo.couponByCouponId.expireDate : '';
    this.couponByCouponId = orderInfo && orderInfo.couponByCouponId ? orderInfo.couponByCouponId : '';
    this.homeInspection = orderInfo && orderInfo.homeInspection ? orderInfo.homeInspection : '';
    this.ddraReport = orderInfo && orderInfo.ddraReport ? orderInfo.ddraReport : '';
    this.structuralEng = orderInfo && orderInfo.structuralEng ? orderInfo.structuralEng : '';
    this.wdo = orderInfo && orderInfo.wdo ? orderInfo.wdo : '';
    this.wellReport = orderInfo && orderInfo.wellReport ? orderInfo.wellReport : '';
    this.firmId = orderInfo && orderInfo.firmId ? orderInfo.firmId : null;
    this.firmName = orderInfo && orderInfo.firmName ? orderInfo.firmName : '';
    this.affiliateId = orderInfo && orderInfo.officeId ? orderInfo.officeId : null;
    this.affiliateName = orderInfo && orderInfo.officeName ? orderInfo.officeName : '';
    this.localMarketId = orderInfo && orderInfo.marketId ? orderInfo.marketId : null;
    this.localMarketName = orderInfo && orderInfo.marketName ? orderInfo.marketName : '';
    this.orderDetailsFormGroup = this.formBuilder.group({
      clientFirstName: [''],
      buyerSellerName: [this.buyerSellerName ? this.buyerSellerName : ''],
      propertyAddress: [''],
      agentType: [this.agentType ? this.agentType : ''],
      agentName: [this.agentName ? this.agentName : ''],
      agentEmail: [this.agentEmail ? this.agentEmail : ''],
      clientMobileNumber: [''],
      additialEmailToSe: [''],
      clientEmail: [this.clientEmail ? this.clientEmail : ''],
      clientPhone: [''],
      emailAgent: [''],
      agentRole: [this.agentRole ? this.agentRole : ''],
      homeInsReport: [''],
      ddraReport: [''],
      wdoReport: [''],
      structEngReport: [''],
      wellReport: [''],
      localMarketId: [this.localMarketId ? this.localMarketId : ''],
      firmId: [this.firmId ? this.firmId : ''],
      affiliateId: [this.affiliateId ? this.affiliateId : ''],
      localMarketName: [this.localMarketName ? this.localMarketName : ''],
      firmName: [this.firmName ? this.firmName : ''],
      affiliateName: [this.affiliateName ? this.affiliateName : '']
    });
    this.oldDataList.push(
      { "firstName": this.firstName },
      { "email": this.email },
      { "agentrole": this.agentType },
      { "phone": this.clientMobileNumber },
      { "billing_myfield23": this.buyerSellerName },
      { "indrole": this.agentRole },
      { "clientphone": this.clientPhone },
      { "clientemail": this.emailAgent },
      { "address": this.subjectPropertyAddress },
      { "billing_myfield24": this.additionalEmail },
      { "homeinsurl": this.homeInspection ? this.homeInspection : "No report found" },
      { "ddraurl": this.ddraReport ? this.ddraReport : "No report found" },
      { "wdourl": this.wdo ? this.wdo : "No report found" },
      { "structengurl": this.structuralEng ? this.structuralEng : "No report found" },
      { "wellurl": this.wellReport ? this.wellReport : "No report found" },
      { "firmsName": this.firmName },
      { "officesName": this.affiliateName },
      { "marketName": this.localMarketName },
    );
  }

  onEditClicked(keyName) {
    if (keyName == this.formValues.clientName) {
      this.clientNameEdit = !this.clientNameEdit;
    }
    else if (keyName == this.formValues.buyerSellerName) {
      this.buyerSellerNameEdit = !this.buyerSellerNameEdit;
    }
    else if (keyName == this.formValues.clientRole) {
      this.agentTpeEdit = !this.agentTpeEdit;
    }
    else if (keyName == this.formValues.agentMobile) {
      this.clientPhoneEdit = !this.clientPhoneEdit;
    }
    else if (keyName == this.formValues.agentEmail) {
      this.agentEmailEdit = !this.agentEmailEdit;
    }
    else if (keyName == this.formValues.clientEmail) {
      this.clientEmailEdit = !this.clientEmailEdit;
    }
    else if (keyName == this.formValues.productOrdered) {
      this.productOrderedEdit = !this.productOrderedEdit;
    }
    else if (keyName == this.formValues.dueDate) {
      this.dueDateEdit = !this.dueDateEdit;
    }
    else if (keyName == this.formValues.additionalEmail) {
      this.additionalEmailEdit = !this.additionalEmailEdit;
    }
    else if (keyName == this.formValues.address) {
      this.subjectPropertyAddressEdit = !this.subjectPropertyAddressEdit;
    }
    else if (keyName == this.formValues.clientMobile) {
      this.clientMobileNumberEdit = !this.clientMobileNumberEdit;
    }
    else if (keyName == this.formValues.orderedDate) {
      this.orderedDateEdit = !this.orderedDateEdit;
    }
    else if (keyName == this.formValues.agentRole) {
      this.agentRoleEdit = !this.agentRoleEdit;
    }
    else if (keyName == this.formValues.homeInspection) {
      this.homeInspectionEdit = !this.homeInspectionEdit;
    }
    else if (keyName == this.formValues.ddra) {
      this.ddraEdit = !this.ddraEdit;
    }
    else if (keyName == this.formValues.wdo) {
      this.wdoEdit = !this.wdoEdit;
    }
    else if (keyName == this.formValues.structuralEng) {
      this.structuralEngEdit = !this.structuralEngEdit;
    }
    else if (keyName == this.formValues.well) {
      this.wellEdit = !this.wellEdit;
    }
    else if (keyName == this.formValues.localMarket) {
      this.localMarketEdit = !this.localMarketEdit;
      this.firmNameEdit = !this.firmNameEdit;
      this.affiliateNameEdit = !this.affiliateNameEdit;
    }
    else if (keyName == this.formValues.firmName) {
      this.firmNameEdit = !this.firmNameEdit;
      this.affiliateNameEdit = !this.affiliateNameEdit;
    }
    else if (keyName == this.formValues.affiliateName) {
      this.affiliateNameEdit = !this.affiliateNameEdit;
      if (this.firmNameEdit) {
        this.firmNameEdit = !this.firmNameEdit;
      }
      if (this.localMarketEdit) {
        this.localMarketEdit = !this.localMarketEdit;
      }
    }
  }
  getEmail(additionalEmailEdit) {
    return (additionalEmailEdit).split(",")
  }
  onEditSave(keyName) {
    if (this.orderDetailsFormGroup.value.localMarketId != null && this.orderDetailsFormGroup.value.affiliateId != null && this.orderDetailsFormGroup.value.firmId != null) {
      let oldData = {}, newData = {}, auditMultipleData = [];
      if (keyName == this.formValues.clientName) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "firstName") {
            oldData = e;
          }
        })
        newData["firstName"] = this.firstName;
      }
      else if (keyName == this.formValues.clientEmail) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "email") {
            oldData = e;
          }
        })
        newData["email"] = this.orderDetailsFormGroup.value.clientEmail;
      }
      else if (keyName == this.formValues.clientRole) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "agentrole") {
            oldData = e;
          }
        })
        newData["agentrole"] = this.agentType;
      }
      else if (keyName == this.formValues.clientMobile) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "phone") {
            oldData = e;
          }
        })
        newData["phone"] = this.clientMobileNumber;
      }
      else if (keyName == this.formValues.buyerSellerName) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "billing_myfield23") {
            oldData = e;
          }
        })
        newData["billing_myfield23"] = this.buyerSellerName;
      }
      else if (keyName == this.formValues.agentRole) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "indrole") {
            oldData = e;
          }
        })
        newData["indrole"] = this.agentRole;
      }
      else if (keyName == this.formValues.agentMobile) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "clientphone") {
            oldData = e;
          }
        })
        newData["clientphone"] = this.clientPhone;
      }
      else if (keyName == this.formValues.agentEmail) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "clientemail") {
            oldData = e;
          }
        })
        newData["clientemail"] = this.emailAgent;
      }
      else if (keyName == this.formValues.address) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "address") {
            oldData = e;
          }
        })
        newData["address"] = this.subjectPropertyAddress;
      }
      else if (keyName == this.formValues.additionalEmail) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "billing_myfield24") {
            oldData = e;
          }
        })
        newData["billing_myfield24"] = this.additionalEmail;
      }
      else if (keyName == this.formValues.homeInspection) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "homeinsurl") {
            oldData = e;
          }
        })
        newData["homeinsurl"] = environment.apiHost + "reports" + "/" + this.orderId + "/" + "HomeInspection" + "/" + this.orderDetailsFormGroup.value.homeInsReport.substr(12, this.orderDetailsFormGroup.value.homeInsReport.length);
      }
      else if (keyName == this.formValues.ddra) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "ddraurl") {
            oldData = e;
          }
        })
        newData["ddraurl"] = environment.apiHost + "reports" + "/" + this.orderId + "/" + "DDRA" + "/" + this.orderDetailsFormGroup.value.ddraReport.substr(12, this.orderDetailsFormGroup.value.ddraReport.length);
      }
      else if (keyName == this.formValues.wdo) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "wdourl") {
            oldData = e;
          }
        })
        newData["wdourl"] = environment.apiHost + "reports" + "/" + this.orderId + "/" + "WDO" + "/" + this.orderDetailsFormGroup.value.wdoReport.substr(12, this.orderDetailsFormGroup.value.wdoReport.length);

      }
      else if (keyName == this.formValues.structuralEng) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "structengurl") {
            oldData = e;
          }
        })
        newData["structengurl"] = environment.apiHost + "reports" + "/" + this.orderId + "/" + "StructuralEng" + "/" + this.orderDetailsFormGroup.value.structEngReport.substr(12, this.orderDetailsFormGroup.value.structEngReport.length);
      }
      else if (keyName == this.formValues.well) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "wellurl") {
            oldData = e;
          }
        })
        newData["wellurl"] = environment.apiHost + "reports" + "/" + this.orderId + "/" + "WellReport" + "/" + this.orderDetailsFormGroup.value.wellReport.substr(12, this.orderDetailsFormGroup.value.wellReport.length);
      }
      else if (keyName == this.formValues.affiliateName) {
        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "marketName") {
            oldData = e;
            newData = { "marketName": this.orderDetailsFormGroup.value.localMarketName };
            auditMultipleData.push({ oldData: oldData, newData: newData });
          }
        })

        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "firmsName") {
            oldData = e;
            newData = { "firmsName": this.orderDetailsFormGroup.value.firmName };
            auditMultipleData.push({ oldData: oldData, newData: newData });
          }
        })

        this.oldDataList.filter((e) => {
          if (Object.keys(e).toString() == "officesName") {
            oldData = e;
            newData = { "officesName": this.orderDetailsFormGroup.value.affiliateName };
            auditMultipleData.push({ oldData: oldData, newData: newData });
          }
        })

      }
      this.isLoading = true;
      this.onEditClicked(keyName);
      this.orderDetails.meta_data.forEach((element, key) => {
        if (element.key == checkoutFields.solEmail) {
          this.orderDetails.meta_data[key].value = keyName == this.formValues.additionalEmail ? this.orderDetailsFormGroup.value.additialEmailToSe : this.additionalEmail;
        }
        if (element.key == checkoutFields.buyerProperty) {
          this.orderDetails.meta_data[key].value = keyName == this.formValues.address ? this.orderDetailsFormGroup.value.propertyAddress : this.subjectPropertyAddress;
        }
        if (element.key == checkoutFields.clientName) {
          this.orderDetails.meta_data[key].value = keyName == this.formValues.clientName ? this.orderDetailsFormGroup.value.buyerSellerName : this.buyerSellerName;
        }
        if (element.key == checkoutFields.agentRole) {
          this.orderDetails.meta_data[key].value = keyName == this.formValues.agentType ? this.orderDetailsFormGroup.value.agentType : this.agentType;
        }
        if (element.key == checkoutFields.agentName) {
          this.orderDetails.meta_data[key].value = this.formValues.agentName ? this.orderDetailsFormGroup.value.agentName : this.agentName;
        }
        if (element.key == checkoutFields.agentEmail) {
          this.orderDetails.meta_data[key].value = this.formValues.agentEmail ? this.orderDetailsFormGroup.value.agentEmail : this.agentEmail;
        }
        if (element.key == checkoutFields.propertyRole) {
          this.orderDetails.meta_data[key].value = this.clientPropertyRole;
        }
      });
      this.orderDetails.line_items[0].meta_data.forEach((element, key) => {
        if (element.key == checkoutFields.homeInspection && keyName == this.formValues.homeInspection && this.orderDetailsFormGroup.value.homeInsReport) {
          this.orderDetails.line_items[0].meta_data[key].value = environment.apiHost + "reports" + "/" + this.orderId + "/" + "HomeInspection" + "/" + this.orderDetailsFormGroup.value.homeInsReport.substr(12, this.orderDetailsFormGroup.value.homeInsReport.length);
        }
        if (element.key == checkoutFields.ddraReport && keyName == this.formValues.ddra && this.orderDetailsFormGroup.value.ddraReport) {
          this.orderDetails.line_items[0].meta_data[key].value = environment.apiHost + "reports" + "/" + this.orderId + "/" + "DDRA" + "/" + this.orderDetailsFormGroup.value.ddraReport.substr(12, this.orderDetailsFormGroup.value.ddraReport.length);
        }
        if (element.key == checkoutFields.wdo && keyName == this.formValues.wdo && this.orderDetailsFormGroup.value.wdoReport) {
          this.orderDetails.line_items[0].meta_data[key].value = environment.apiHost + "reports" + "/" + this.orderId + "/" + "WDO" + "/" + this.orderDetailsFormGroup.value.wdoReport.substr(12, this.orderDetailsFormGroup.value.wdoReport.length);
        }
        if (element.key == checkoutFields.structuralEng && keyName == this.formValues.structuralEng && this.orderDetailsFormGroup.value.structEngReport) {
          this.orderDetails.line_items[0].meta_data[key].value = environment.apiHost + "reports" + "/" + this.orderId + "/" + "StructuralEng" + "/" + this.orderDetailsFormGroup.value.structEngReport.substr(12, this.orderDetailsFormGroup.value.structEngReport.length);
        }
        if (element.key == checkoutFields.well && keyName == this.formValues.well && this.orderDetailsFormGroup.value.wellReport) {
          this.orderDetails.line_items[0].meta_data[key].value = environment.apiHost + "reports" + "/" + this.orderId + "/" + "WellReport" + "/" + this.orderDetailsFormGroup.value.wellReport.substr(12, this.orderDetailsFormGroup.value.wellReport.length);
        }
      });
      this.orderDetails.billing.email = this.orderDetailsFormGroup.value.clientEmail ? this.orderDetailsFormGroup.value.clientEmail : this.email;
      this.orderDetails.billing.phone = this.clientMobileNumber;
      this.orderDetails.billing.first_name = this.orderDetailsFormGroup.value.clientFirstName ? this.orderDetailsFormGroup.value.clientFirstName : this.firstName;
      let finalOrderInfo = JSON.stringify(this.orderDetails);
      let address = this.orderDetailsFormGroup.value.propertyAddress ? this.orderDetailsFormGroup.value.propertyAddress : this.subjectPropertyAddress;
      let firstName = this.orderDetailsFormGroup.value.clientFirstName ? this.orderDetailsFormGroup.value.clientFirstName : this.firstName;
      let agentrole = this.orderDetailsFormGroup.value.agentType ? this.orderDetailsFormGroup.value.agentType : this.agentType;
      let clientphone = this.orderDetailsFormGroup.value.clientPhone ? this.orderDetailsFormGroup.value.clientPhone : this.clientPhone;
      let clientemail = this.orderDetailsFormGroup.value.emailAgent ? this.orderDetailsFormGroup.value.emailAgent : this.emailAgent;
      let indrole = this.orderDetailsFormGroup.value.agentRole ? this.orderDetailsFormGroup.value.agentRole : this.agentRole;
      let firmId = this.orderDetailsFormGroup.value.firmId ? this.orderDetailsFormGroup.value.firmId : this.firmId;
      let officeId = this.orderDetailsFormGroup.value.affiliateId ? this.orderDetailsFormGroup.value.affiliateId : this.affiliateId;
      let marketId = this.orderDetailsFormGroup.value.localMarketId ? this.orderDetailsFormGroup.value.localMarketId : this.localMarketId;
      this.localMarketName = this.orderDetailsFormGroup.value.localMarketId ? this.orderDetailsFormGroup.value.localMarketName : this.localMarketName;
      this.firmName = this.orderDetailsFormGroup.value.localMarketId ? this.orderDetailsFormGroup.value.firmName : this.firmName;
      this.affiliateName = this.orderDetailsFormGroup.value.localMarketId ? this.orderDetailsFormGroup.value.affiliateName : this.affiliateName;
      let updatePaylaod = {
        "editedAt": new Date(),
        "editedBy": this.userId,
        "orderContent": finalOrderInfo,
        "address": address,
        "firstName": firstName,
        "agentrole": agentrole,
        "clientphone": clientphone,
        "clientemail": clientemail,
        "indrole": indrole,
        "firmId": firmId,
        "officeId": officeId,
        "marketId": marketId
      }
      if (keyName == this.formValues.homeInspection && this.orderDetailsFormGroup.value.homeInsReport) {
        updatePaylaod['homeinsurl'] = environment.apiHost + "reports" + "/" + this.orderId + "/" + "HomeInspection" + "/" + this.orderDetailsFormGroup.value.homeInsReport.substr(12, this.orderDetailsFormGroup.value.homeInsReport.length);
      }
      else if (keyName == this.formValues.ddra && this.orderDetailsFormGroup.value.ddraReport) {
        updatePaylaod['ddraurl'] = environment.apiHost + "reports" + "/" + this.orderId + "/" + "DDRA" + "/" + this.orderDetailsFormGroup.value.ddraReport.substr(12, this.orderDetailsFormGroup.value.ddraReport.length);
      }
      else if (keyName == this.formValues.wdo && this.orderDetailsFormGroup.value.wdoReport) {
        updatePaylaod['wdourl'] = environment.apiHost + "reports" + "/" + this.orderId + "/" + "WDO" + "/" + this.orderDetailsFormGroup.value.wdoReport.substr(12, this.orderDetailsFormGroup.value.wdoReport.length);
      }
      else if (keyName == this.formValues.structuralEng && this.orderDetailsFormGroup.value.structEngReport) {
        updatePaylaod['structengurl'] = environment.apiHost + "reports" + "/" + this.orderId + "/" + "StructuralEng" + "/" + this.orderDetailsFormGroup.value.structEngReport.substr(12, this.orderDetailsFormGroup.value.structEngReport.length);
      }
      else if (keyName == this.formValues.well && this.orderDetailsFormGroup.value.wellReport) {
        updatePaylaod['wellurl'] = environment.apiHost + "reports" + "/" + this.orderId + "/" + "WellReport" + "/" + this.orderDetailsFormGroup.value.wellReport.substr(12, this.orderDetailsFormGroup.value.wellReport.length);
      }
      // update order value in DB query Call
      this.ordersService.editOrders(this.nodeId, updatePaylaod).then((editRes) => {
        if (editRes && editRes['data'] && editRes['data'].updateOrder && editRes['data'].updateOrder.order && editRes['data'].updateOrder.order.id) {
          this.editOrderResponse = editRes;
          if (keyName == this.formValues.homeInspection && this.orderDetailsFormGroup.value.homeInsReport) {
            this.ordersService.reportUpload(this.productReports.get('homeInsReport'), this.orderId, 'HomeInspection').then((reportRes) => {
              this.isReportUpdated.emit(true);
              console.log(`Home Inspection upload succesfully at ${this.orderId}`);
              this.isLoading = false;
            }).catch((reportErr) => {
              console.log(`Home Inspection upload succesfully at ${this.orderId}`, reportErr);
            });
          }
          else if (keyName == this.formValues.ddra && this.orderDetailsFormGroup.value.ddraReport) {
            this.ordersService.reportUpload(this.productReports.get('ddraReport'), this.orderId, 'DDRA').then((reportRes) => {
              this.isReportUpdated.emit(true);
              console.log(`DDRA upload succesfully at ${this.orderId}`);
              this.isLoading = false;
            }).catch((reportErr) => {
              console.log(`Home Inspection upload failed at ${this.orderId}`, reportErr);
            });
          }
          else if (keyName == this.formValues.wdo && this.orderDetailsFormGroup.value.wdoReport) {
            this.ordersService.reportUpload(this.productReports.get('wdoReport'), this.orderId, 'WDO').then((reportRes) => {
              this.isReportUpdated.emit(true);
              console.log(`WDO report upload succesfully at ${this.orderId}`);
              this.isLoading = false;
            }).catch((reportErr) => {
              console.log(`WDO report upload failed at ${this.orderId}`, reportErr);
            });
          }
          else if (keyName == this.formValues.structuralEng && this.orderDetailsFormGroup.value.structEngReport) {
            this.ordersService.reportUpload(this.productReports.get('structEngReport'), this.orderId, 'StructuralEng').then((reportRes) => {
              this.isReportUpdated.emit(true);
              this.isLoading = false;
              console.log(`Structral Engg upload succesfully at ${this.orderId}`);
            }).catch((reportErr) => {
              console.log(`Structral Engg upload failed at ${this.orderId}`, reportErr);
            });
          }
          else if (keyName == this.formValues.well && this.orderDetailsFormGroup.value.wellReport) {
            this.ordersService.reportUpload(this.productReports.get('wellReport'), this.orderId, 'WellReport').then((reportRes) => {
              this.isReportUpdated.emit(true);
              console.log(`Well report upload succesfully at ${this.orderId}`);
              this.isLoading = false;
            }).catch((reportErr) => {
              console.log(`Well report upload failed at ${this.orderId} `, reportErr);
            });
          }
          else {
            this.isReportUpdated.emit(true);
            this.isLoading = false;
          }
          this.orderInfo();
          if (auditMultipleData.length > 0) {
            auditMultipleData.forEach((res, i) => {
              setTimeout(() => {
                this.auditHistoryFunCall("Success", res.oldData, res.newData);
              }, i * 500);
            })
          }
          else {
            this.auditHistoryFunCall("Success", oldData, newData);
          }
          this.showToast('success');
          if (this.data) {
          }
          this.isLoading = false;
        }
        else {
          if (auditMultipleData.length > 0) {
            auditMultipleData.forEach((res, i) => {
              setTimeout(() => {
                this.auditHistoryFunCall("Failed", res.oldData, res.newData);
              }, i * 500);
            })
          }
          else {
            this.auditHistoryFunCall("Failed", oldData, newData);
          }
          if (this.data) {
          }
          this.showToast('failed')
        }
      }).catch((err) => {
        console.log("err11111111111", err);
        this.orderInfo();
        if (this.data) {
        }
        this.isLoading = false;
        this.showToast('failed')
        console.log("err in order Details Error", err);
      });
    }
    else {
      this.showToastMessage('Please fill all fields', 'warning');
    }
  }

  //Show toast message
  showToast(message) {
    this.toastComponent.showToast(
      message == 'success'
        ? this.toastMsg.editSuccess
        : this.toastMsg.editFailed
    );
  }

  // Get all stored stripes details  from backend
  getAllInvoices() {
    this.ordersService.GetOrderBasedStripeInvoice(Number(this.currentOrderId))
      .then((stripedata: any) => {
        if (stripedata && stripedata.length > 0) {
          var findResultInvoiceJson = stripedata[0] && stripedata[0].invoiceObject ? JSON.parse(stripedata[0].invoiceObject) : ''; //invocie
          var findResultChargeJson = stripedata[0] && stripedata[0].chargeObject ? JSON.parse(stripedata[0].chargeObject) : ''; // after charge
          this.invoiceObject = stripedata[0] && stripedata[0].invoiceObject ? JSON.parse(stripedata[0].invoiceObject) : ''; //invocie
          this.chargeObject = stripedata[0] && stripedata[0].chargeObject ? JSON.parse(stripedata[0].chargeObject) : ''; // 
          this.invoiceStatus = findResultInvoiceJson && findResultInvoiceJson.status ? findResultInvoiceJson.status : '';
          this.receiptUrlOfCheckout = findResultChargeJson && findResultChargeJson.receipt_url ? findResultChargeJson.receipt_url : '';
          this.hostedInvoiceURL = findResultInvoiceJson && findResultInvoiceJson.hosted_invoice_url ? findResultInvoiceJson.hosted_invoice_url : null;
          if (stripedata && stripedata.length > 0 && stripedata[0].chargeObject && stripedata[0].chargeObject != null) {
            this.transactionID = findResultChargeJson && findResultChargeJson.id ? findResultChargeJson.id : null;
          }
        }
        this.paymentStatus = this.invoiceObject && this.chargeObject ? "Payment Done" : (this.chargeObject ? "Payment Done" : (this.invoiceObject && !this.chargeObject ? "Waiting for client pay" : "Payment Not Done"));
      })
      .catch(err => {
        console.log("stripe error", err)
      })
  }

  openReceipt(link) {
    link ? window.open(link, '_blank') :
      this.toastComponent.showToast(this.toastMsg.noReceipt);


  }

  goback() {
    this.router.navigate(['/apps/e-commerce/orders']);
  }

  auditHistoryFunCall(status, oldData, newData) {

    let auditLogPayload = {
      roleId: this.roleId,
      userId: this.userId,
      orderId: Number(this.orderId),
      newData: newData,
      oldData: oldData,
      auditType: "update_order",
      logsDesc: "Order Updated",
      platform: "Executive Dashboard",
      status: status
    };
    this.oldDataList = [];
    this.auditHistoryService.auditHistoryCall(auditLogPayload);
  }

  onOpenPdf(url) {
    window.open(url, "_blank")
  }

  onFileSelected(file_type, event) {
    this.productReports.set(file_type, event.target.files[0]);
  }

  async fetchMarkets() {
    await this.ordersService.fetchAllMarkets().then(async (marketList: any) => {

      await this.ordersService.formatMarketData(marketList).then((formatMarkets: any) => {
        this.markets = [...formatMarkets];
        this.marketsDropDownMenu = [...formatMarkets];
        this.fetchFirms();
      }).catch(() => {
        this.markets = [];
      });

    }).catch((marketsError) => {
      console.log("marketsError:", marketsError)
    })
  }

  async fetchFirms() {
    if (this.orderDetailsFormGroup.value.localMarketId) {
      this.isLoadingList = true;
      await this.ordersService.fetchAllFirms(this.orderDetailsFormGroup.value.localMarketId).then(async (firmsList: any) => {
        await this.ordersService.formatFirmsData(firmsList).then((formatFirms: any) => {
          this.firms = [...formatFirms];
          this.firmsDropDownMenu = [...formatFirms];
          this.isLoadingList = false;
          this.fetchOffice();
        }).catch(() => {
          this.firms = [];
          this.isLoadingList = false;
        });
      }).catch((firmsError) => {
        console.log("firmsError:", firmsError)
        this.isLoadingList = false;
      })
    } else {
      this.firms = [];
      this.firmsDropDownMenu = [];
      let tempObj = {
        firmId: null,
        firmsName: "Other",
      };
      this.firms.push(tempObj);
      this.firmsDropDownMenu.push(tempObj);
    }

  }

  async fetchOffice() {
    if (this.orderDetailsFormGroup.value.firmId) {
      this.isLoadingList = true;
      await this.ordersService.fetchallOffices(this.orderDetailsFormGroup.value.firmId, this.orderDetailsFormGroup.value.localMarketId).then(async (officeList: any) => {
        await this.ordersService.formatofficeData(officeList).then((formatOffices: any) => {
          this.offices = [...formatOffices];
          this.officesDropDownMenu = [...formatOffices];
          this.isLoadingList = false;

        }).catch(() => {
          this.offices = [];
          this.isLoadingList = false;
        });

      }).catch((officeError) => {
        console.log("officeError:", officeError);
        this.isLoadingList = false;

      })
    } else {
      this.offices = [];
      this.officesDropDownMenu = [];
      let tempObj = {
        officeId: null,
        officesName: "Other",
      };
      this.offices.push(tempObj);
      this.officesDropDownMenu.push(tempObj);
    }

  }

  onKeyChange(event, originalList, dropDownType, propertyName) {
    if (event.target.value) {
      let filteredData = this.filter(event.target.value, originalList, propertyName);
      if (dropDownType == 'localMarketName') {
        this.marketsDropDownMenu = filteredData;
      }
      else if (dropDownType == 'firmName') {
        this.firmsDropDownMenu = filteredData;
      }
      else if (dropDownType == 'affiliateName') {
        this.officesDropDownMenu = filteredData;
      }
    }
    else {
      if (dropDownType == 'localMarketName') {
        this.marketsDropDownMenu = this.markets;
      }
      else if (dropDownType == 'firmName') {
        this.firmsDropDownMenu = this.firms;
      }
      else if (dropDownType == 'affiliateName') {
        this.officesDropDownMenu = this.offices;
      }
    }
  }

  filter(val: string, dropDownList, propertyName) {
    return dropDownList.filter(option =>
    ((option[propertyName] && option[propertyName].toLowerCase().indexOf(val.toLowerCase()) !== -1) ||
      (option[propertyName] && option[propertyName].toLowerCase().indexOf(val.toLowerCase()) !== -1))
    );
  }

  async onSelect(selectItem, type) {
    if (type === 'localMarketName') {
      this.orderDetailsFormGroup.get('localMarketId').setValue(selectItem.marketId);
      this.orderDetailsFormGroup.get('localMarketName').setValue(selectItem.marketName);
      this.orderDetailsFormGroup.get('firmId').setValue(null);
      this.orderDetailsFormGroup.get('firmName').setValue(null);
      this.orderDetailsFormGroup.get('affiliateId').setValue(null);
      this.orderDetailsFormGroup.get('affiliateName').setValue(null);
      await this.fetchFirms();
    } else if (type === 'firmName') {
      this.orderDetailsFormGroup.get('firmId').setValue(selectItem.firmId);
      this.orderDetailsFormGroup.get('firmName').setValue(selectItem.firmsName);
      this.orderDetailsFormGroup.get('affiliateId').setValue(null);
      this.orderDetailsFormGroup.get('affiliateName').setValue(null);
      await this.fetchOffice();
    } else if (type === 'affiliateName') {
      this.orderDetailsFormGroup.get('affiliateId').setValue(selectItem.officeId);
      this.orderDetailsFormGroup.get('affiliateName').setValue(selectItem.officesName);
    }
  }

  showToastMessage(message: string, toastType: string) {
    this._matSnackBar.open(message, 'OK', {
      verticalPosition: 'top',
      duration: 2000,
      panelClass: [toastType],
    });
  }

  orderInfo() {
    this.commonOrdersService.getOrderByOrderIdNew(this.currentOrderId).then((response: any) => {
      let tempOrderArray = response && response.data && response.data.allOrders && response.data.allOrders.nodes.length > 0 ? response.data.allOrders.nodes : null;
      if (tempOrderArray) {
        this.commonOrdersService.checkDocProcess(tempOrderArray).then((ordersRes: any) => {
          if (ordersRes && ordersRes.length > 0) {
            this.currentOrderInfo = ordersRes[0];
            this.formatOrderData(this.currentOrderInfo);
            this.isLoading = false;
          }
          else {
            this.currentOrderInfo = tempOrderArray && tempOrderArray.length > 0 ? tempOrderArray[0] : null;
            this.formatOrderData(this.currentOrderInfo);
            this.isLoading = false;
          }
        });
      }
      else {
        this.isLoading = false;
      }
    }).catch((err) => {
      this.isLoading = false;
    });
  }


  viewLog() {

    this.dialogRefAudit = this.dialog.open(OrderViewLogsDialogComponent, {
      width: '100%',
      panelClass: 'log-info-dialog',
      data: {
        orderId: Number(this.orderId)
      }
    });

    this.dialogRefAudit.afterClosed()
      .subscribe(response => {
      })
  }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/orders-edit-new/orders-edit-new.component.ts